import { Capacitor } from '@capacitor/core';
import { PlatformString } from '@sworkit/api';
import { Network } from '@capacitor/network';
import { remoteConfig } from './firebase';
import { fetchAndActivate } from "firebase/remote-config";

import SworkitMobile, { FirebaseRemoteConfigKey } from './sworkit-mobile/sw-mobile';

declare var Ionic;
export async function isOnWifi() {
  try {
    const networkStatus = await Network.getStatus();
    if (
      networkStatus &&
      networkStatus.connected &&
      networkStatus.connectionType === 'wifi'
    ) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.debug(err);
    return false;
  }
}

export async function getLocalAsset(
  url: string,
  isAudio?: boolean
): Promise<string> {
  if (url && Capacitor.isNativePlatform()) {
    try {
      const foundFile = await SworkitMobile.findLocalFileFromUrl({ url });
      if (foundFile && foundFile.localPath) {
        if (isAudio) {
          return foundFile.localPath;
        } else {
          return Ionic.WebView.convertFileSrc(foundFile.localPath);
        }
      } else {
        return foundFile.remoteUrl;
      }
    } catch (error) {
      console.error('local file error: ', error);
    }
  } else {
    return url;
  }
}

//todo: add web functionality to SworkitMobile
export async function initRemoteConfig() {
  
  try {
    const { connected } = await Network.getStatus();
    if (!connected) return;
    if (Capacitor.isNativePlatform()) {
      return SworkitMobile.fetchAndActivateRemoteConfig();
    } else {
      await fetchAndActivate(remoteConfig)
    }
  } catch (err) {
    console.error('remote config error', err);
  }
}

export async function getRemoteConfigValueForKey<T>(
  options: FirebaseRemoteConfigKey
) {
  if (
    !SworkitMobile.getRemoteConfigValueForKey ||
    !Capacitor.isNativePlatform()
  )
    return null;
  try {
    const {
      remoteConfigValue,
    } = await SworkitMobile.getRemoteConfigValueForKey<T>(options);
    return remoteConfigValue;
  } catch (err) {
    console.debug('error getRemoteConfigValueForKey', err);
    return null;
  }
}

export function getStoreName() {
  const platform = Capacitor.getPlatform() as PlatformString;
  if (platform === 'ios') {
    return 'iTunes';
  } else if (platform === 'android') {
    return 'Google Play';
  } else {
    return 'Sworkit';
  }
}

export function getLegacyNativeHealthIntegration() {
  const platform = Capacitor.getPlatform() as PlatformString;
  switch (platform) {
    case 'ios':
      return 'apple-health';
    case 'android':
      return 'google-fit'
    default:
      return;
  }
}
